import CircularProgress from '@mui/material/CircularProgress';
export const GradientCircularProgress = ({width}) => {
    return (
        <>
            <svg width={0} height={0}>
                <defs>
                    <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor="#e01cd5" />
                        <stop offset="100%" stopColor="#1CB5E0" />
                    </linearGradient>
                </defs>
            </svg>
            {width && width>0 ?
            <CircularProgress size={1 * width} sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} /> :
        <CircularProgress size={width} sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} /> }
            
        </>
    );
}